export type KnownEvents =
	| "lex"
	| "parse"
	| "spans"
	| "resolve"
	| "read-builtin"
	| "clear-old"
	| "collect-top"
	| "resolve-bodies";

/**
 * Performance counters for profiling and optimizing the parser.
 */
export class PerfCounters {
	private _counters: Map<KnownEvents, number> = new Map();
	private _startTimes: Map<KnownEvents, number> = new Map();

	start(eventType: KnownEvents) {
		if (this._startTimes.has(eventType)) {
			console.warn(`Already started performance timer ${eventType}`);
		}
		this._startTimes.set(eventType, performance.now());
	}

	end(eventType: KnownEvents) {
		if (!this._startTimes.has(eventType)) {
			console.warn(`Performance timer ${eventType} not started`);
			return;
		}
		const start = this._startTimes.get(eventType)!;
		const end = performance.now();
		this._startTimes.delete(eventType);
		this._counters.set(
			eventType,
			(this._counters.get(eventType) || 0) + end - start
		);
	}

	merge(other: PerfCounters) {
		for (const [key, value] of other._counters.entries()) {
			this._counters.set(key, (this._counters.get(key) || 0) + value);
		}
		return this;
	}

	scale(number: number) {
		for (const [key, value] of this._counters.entries()) {
			this._counters.set(key, value * number);
		}
		return this;
	}

	summarize() {
		console.log(this._counters);
	}
}
